import { configureStore } from '@reduxjs/toolkit';
import bookingSlice from './bookingSlice'

export default configureStore({
  reducer: {
    bookingSlice:bookingSlice
  },
});
